import { createContext, useContext } from 'react';

export type PermissionsContract = {
  resources: Record<string, Record<string, boolean>>;
  refetchPermissions?: () => void;
  hasResourcePermission: (
    resource: string | string[],
    actions: string | string[],
    requireAny?: boolean,
  ) => boolean;
  hasResourcePermissionNew: ({
    action,
    year,
    institutionId,
    sdgId,
    availableImpactYears,
    isDuringEmbargo,
  }: {
    action: string;
    year?: number;
    institutionId: string;
    sdgId?: number;
    availableImpactYears?: number[];
    isDuringEmbargo?: boolean;
  }) => boolean;
  getFirstRoleOfUser: <T extends string>(
    rolesTocheck: readonly T[],
    institutionId: string,
  ) => T | null;
  getYearsForSDGRole: (
    role: string,
    availableImpactYears: number[],
  ) => number[];
  getAvailableSdgYears: (
    availableImpactYears: number[],
    institutionId: string,
    isDuringEmbargo?: boolean,
  ) => number[];
  hasRole: (role: string | string[], requireAny?: boolean) => boolean;
  hasClientRole: (
    client: string,
    role: string | string[],
    requireAny?: boolean,
  ) => boolean;
  hasGroup: (role: string | string[], requireAny?: boolean) => boolean;
  // Need to sort the return typing later...
  getUserAvailableYearsForProduct: (
    institutionId: string,
    partialProductName: string,
  ) => any;
};

export const defaultContextValue = {
  hasResourcePermission: () => false,
  hasResourcePermissionNew: () => false,
  getFirstRoleOfUser: () => null,
  getYearsForSDGRole: () => [],
  getAvailableSdgYears: () => [],
  hasRole: () => false,
  hasClientRole: () => false,
  hasGroup: () => false,
  global: {},
  resources: {},
  getUserAvailableYearsForProduct: () => null,
};

const PermissionsContext = createContext<PermissionsContract>({
  ...defaultContextValue,
});

export const usePermissions = () => useContext(PermissionsContext);

export default PermissionsContext;
